export default __webpack_public_path__ + "static/wincor-8b4a70a82e358658570134e8d4114ea4.jpg";